import { Component, OnInit, OnDestroy } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { AppService } from 'src/app/app.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Title } from '@angular/platform-browser';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { LocalStorageService } from '../landingpage/product-list/localStorageService';
import { Subscription } from 'rxjs';
import { SelectionService } from './service';

declare var google: any;
declare let fbq: Function;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss', './header.component.css'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  default_Image: any = '/assets/images/default_category.png';
  private localStorageChangeSubscription: Subscription;
  isWebLoginVisible = false;
  isuserLoged = false;
  LoginVisible = false;
  isLoactionVisible = false;
  isBottomNavbarShoning = true;
  searchMode = '1';
  locationArray = [
    {
      type: 'Home',
    },
    {
      type: 'Work',
    },
    {
      type: 'Other',
    },
  ];
  StoresData = ['Hyderabad', 'Gachibowlly', 'Lingampally', 'Kukatpally'];
  userName: any;
  userNumber: any;
  image: any;

  search_value: string = '';
  auto: any;
  limit = 10;
  skip = 0;
  ProductListData: any = [];
  compositionListData: any = [];
  brandProductsList: any = [];
  isLoading: boolean = false;
  isProductLoading: boolean;
  CartId: any;
  isMoleculeLoading: boolean = false;
  pinCode = new FormControl('');
  previousWarehouseId: any = '';
  selectedwarehouse = new FormControl(null);
  cartItemsCount: number = 0;
  warehouseList: any = [];
  cityName = 'Select Location';
  brandProducts: boolean = false;
  private debounceTimer: any;
  addressList: any = [];
  pincode: any = '';
  initial: any = true;
  lng: number;
  lat: number;
  currentUrl: string;
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private localStorageService: LocalStorageService,
    private acitvatedRoute: ActivatedRoute,
    private CookieService: CookieService,
    public _appService: AppService,
    private titleService: Title,
    private nzMessageService: NzMessageService,
    private selectionService: SelectionService
  ) {
    let activatedUrl: string = router.url;
    let preferenceUrl = activatedUrl.split('/');

    let generatedUrl: string = preferenceUrl[1];
    this.currentUrl = generatedUrl;
    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
      }
      if (router.url != 'HealthArtical-detail') {
        this.titleService.setTitle(
          'Medbuzz: Indian Online Pharmacy | Buy generic Medicines Online'
        );
      }
      let currentuRl = router.url;
      let FinalUrl = currentuRl.split('/')[1];
      let FinalUrl1 = currentuRl.split('?')[0];
      if (
        router.url == '/upload-prescription' ||
        router.url == '/payment-process' ||
        router.url == '/MyCart' ||
        router.url == '/product-detail' ||
        router.url == '/login' ||
        router.url == '/about-us' ||
        router.url == '/user-prescription' ||
        router.url == '/user-profile/add-address' ||
        router.url == '/user-profile/Profile' ||
        router.url == '/blog' ||
        router.url == '/user-profile/Wallet' ||
        router.url == '/user-profile/Wishlist' ||
        router.url == '/user-profile/req-availability' ||
        router.url == '/user-profile/Saved-Prescription' ||
        router.url == '/FAQs' ||
        router.url == '/terms-conditions' ||
        router.url == '/privacy-policy' ||
        router.url == '/Notify' ||
        router.url == '/contact-us' ||
        router.url == '/user-profile/My-Requests' ||
        router.url == '/user-profile/my-orders' ||
        router.url == '/request-call' ||
        FinalUrl == 'HealthArtical-detail' ||
        FinalUrl == 'product-detail' ||
        FinalUrl1 == '/category' ||
        router.url == '/all-product' ||
        router.url == '/all-recently-products'
      ) {
        this.isBottomNavbarShoning = false;
      } else {
        this.isBottomNavbarShoning = true;
      }
      if (
        router.url == '/privacy-policy' ||
        router.url == '/terms-conditions'
      ) {
        this.isLoactionVisible = false;
      } else {
        if (this.CookieService.check('cityData')) {
          let cityData: any = JSON.parse(this.CookieService.get('cityData'));
          if (cityData == null || cityData == '') {
            // this.isLoactionVisible = true
            // this.getCurrentlocation()
            this.pincode = 500019;
            this.checkPincode(2);
          } else {
            this.cityName = cityData.Division;
          }
        } else {
          // this.isLoactionVisible = true
          // this.getCurrentlocation()
          this.pincode = 500019;
          this.checkPincode(2);
        }
      }
    });
    this._appService.isWebLoginVisible.subscribe((data: boolean) => {
      this.isWebLoginVisible = data;
    });
    this._appService.LoginVisible.subscribe((data: boolean) => {
      this.LoginVisible = data;
      this.getAllAddresses();
    });

    this._appService.logOutEventEmitter.subscribe((data: any) => {
      if (data.emittingType == 2) {
        this.isuserLoged = false;
        this.getCartItemsList();
      } else {
        this.isuserLoged = true;
        this.getProfileInfo();
      }
      // let userData = data.userData
      // this.userName = userData.Name
    });
    this._appService.cartInfoEventEmitter.subscribe((data: any) => {
      this.cartItemsCount = data.length;
    });
  }
  onLocalStorageChange() {
    const selectedOption = this.localStorageService.getItem('warehouseId');
    console.log(
      selectedOption,
      this.previousWarehouseId,
      this.selectedwarehouse.value
    );
    if (selectedOption != this.selectedwarehouse.value) {
      this.selectedwarehouse.setValue(selectedOption);

      this.previousWarehouseId = selectedOption;
    }
  }
  ngOnDestroy() {
    this.localStorageChangeSubscription.unsubscribe();
  }
  ngOnInit() {
    // this.localStorageChangeSubscription = this.localStorageService
    //   .getLocalStorageChangeObservable()
    //   .subscribe(() => {
    //     this.onLocalStorageChange();
    //   });
    this.getAllWarehouse();
    if (
      this.currentUrl == 'privacy-policy' ||
      this.currentUrl == 'terms-conditions'
    ) {
      this.isLoactionVisible = false;
    } else {
      if (this.CookieService.check('cityData')) {
        let cityData: any = JSON.parse(this.CookieService.get('cityData'));
        if (cityData == null || cityData == '') {
          // this.isLoactionVisible = true
          // this.getCurrentlocation()
          this.pincode = 500019;
          this.checkPincode(2);
        } else {
          this.cityName = cityData.Division;
        }
      } else {
        // this.isLoactionVisible = true
        // this.getCurrentlocation()
        this.pincode = 500019;
        this.checkPincode(2);
      }
    }
    this.selectedwarehouse.valueChanges.subscribe((data) => {
      if (
        this.CookieService.check('userData') &&
        !this.initial &&
        this.previousWarehouseId != data
      ) {
        const isConfirmed = confirm(
          `Do you want to change the Warehouse this may delete existing cart Data ?`
        );
        if (isConfirmed) {
          localStorage.setItem('warehouseId', data);
          this.updateWarehouse(data);
          this.clearCart(this.CartId);
          this.search_value = '';
          this.previousWarehouseId = data;
          this.localStorageService.setItem('warehouseId', data);
          this.selectionService.setSelectedOption(data);
          console.log('local1');
        } else {
          this.selectedwarehouse.setValue(this.previousWarehouseId);
        }
      } else {
        this.initial = false;
        this.search_value = '';
        console.log('123456789');
        this.previousWarehouseId = data;
        this.localStorageService.setItem('warehouseId', data);
        this.selectionService.setSelectedOption(data);
        console.log('local');
      }
    });
    if (this.CookieService.check('userData')) {
      let userData = JSON.parse(this.CookieService.get('userData'));
      if (userData.USERID.trim().length > 0) {
        this.isuserLoged = true;
        this.getProfileInfo();
        this.getCartItemsList();
        this.getAllAddresses();
      } else {
        this.isuserLoged = false;
      }
    } else {
    }
  }
  updateWarehouse(id: any) {
    console.log(id);
    try {
      this._appService
        .postMethod('Update_User_Warehouse', { warehouseId: id })

        .subscribe(
          (resp) => {},
          (resp) => {
            // this.errorTip = resp.error.extras.msg
          }
        );
    } catch (e) {
      alert('something went wrong');
      console.log(e);
    }
  }
  getAllWarehouse() {
    try {
      this._appService
        .postMethod('Fetch_Warehouses', {})

        .subscribe(
          (resp) => {
            this.warehouseList = resp.extras.Data;
            this.localStorageService.setItem(
              'warehouseId',
              resp.extras.Data[0].warehouseId
            );
            if (!this.CookieService.check('userData')) {
              this.selectedwarehouse.setValue(
                this.warehouseList[0].warehouseId
              );

              this.previousWarehouseId = this.warehouseList[0].warehouseId;
            }
          },
          (resp) => {
            // this.errorTip = resp.error.extras.msg
          }
        );
    } catch (e) {
      alert('something went wrong');
      console.log(e);
    }
  }
  onMobileLogin(logType: number) {
    if (logType == 1) {
      this.router.navigateByUrl('/login');
      window.scroll({ top: 0, behavior: 'smooth' });
      // this.isWebLoginVisible = true
      // this._appService.showPage.emit(1)
    } else if (logType == 2) {
      console.log('zzzzzzzz');
      this.LoginVisible = true;
      this._appService.showPage.emit(1);
    }
  }
  webLoginCancel() {
    this.isWebLoginVisible = false;
  }
  Loginclose() {
    this.LoginVisible = false;
  }
  OnClickHome() {
    this.router.navigateByUrl('/');
    this.LoginVisible = false;
  }
  onclicksignup(type: number) {
    if (type == 1) {
      this.router.navigate(['/login']);
      this.LoginVisible = false;
    }
  }
  selsetedProfile(type: number) {
    if (type == 1) {
      this.router.navigateByUrl('/user-profile/my-orders');
      window.scroll({ top: 0, behavior: 'smooth' });
      this.LoginVisible = false;
    } else if (type == 2) {
      this.router.navigateByUrl('/user-profile/add-address');
      window.scroll({ top: 0, behavior: 'smooth' });
      this.LoginVisible = false;
    } else if (type == 3) {
      this.router.navigateByUrl('/user-profile/Profile');
      window.scroll({ top: 0, behavior: 'smooth' });
      this.LoginVisible = false;
    } else if (type == 4) {
      this.router.navigateByUrl('/user-profile/Saved-Prescription');
      window.scroll({ top: 0, behavior: 'smooth' });
      this.LoginVisible = false;
    } else if (type == 5) {
      this.router.navigateByUrl('/user-profile/Coupons');
      window.scroll({ top: 0, behavior: 'smooth' });
      this.LoginVisible = false;
    } else if (type == 6) {
      this.router.navigateByUrl('/user-profile/Wishlist');
      window.scroll({ top: 0, behavior: 'smooth' });
      this.LoginVisible = false;
    } else if (type == 7) {
      this.router.navigateByUrl('/FAQs');
      window.scroll({ top: 0, behavior: 'smooth' });
      this.LoginVisible = false;
    } else if (type == 8) {
      this.router.navigateByUrl('/Health-Articals');
      window.scroll({ top: 0, behavior: 'smooth' });
      this.LoginVisible = false;
    } else if (type == 9) {
      this.router.navigateByUrl('/about-us');
      window.scroll({ top: 0, behavior: 'smooth' });
      this.LoginVisible = false;
    } else if (type == 10) {
      this.router.navigateByUrl('/terms-conditions');
      window.scroll({ top: 0, behavior: 'smooth' });
      this.LoginVisible = false;
    } else if (type == 11) {
      this.router.navigateByUrl('/Privacy-Policy');
      window.scroll({ top: 0, behavior: 'smooth' });
      this.LoginVisible = false;
    } else if (type == 12) {
      this.router.navigateByUrl('/all-product');
      window.scroll({ top: 0, behavior: 'smooth' });
      this.LoginVisible = false;
    } else if (type == 13) {
      this.router.navigateByUrl('/user-profile/req-availability');
      window.scroll({ top: 0, behavior: 'smooth' });
      this.LoginVisible = false;
    } else if (type == 14) {
      this.router.navigateByUrl('/request-call');
      window.scroll({ top: 0, behavior: 'smooth' });
      this.LoginVisible = false;
    } else if (type == 15) {
      this.router.navigateByUrl('/Contact-us');
      window.scroll({ top: 0, behavior: 'smooth' });
      this.LoginVisible = false;
    } else if (type == 16) {
      this.router.navigateByUrl('/user-profile/Wallet');
      window.scroll({ top: 0, behavior: 'smooth' });
      this.LoginVisible = false;
    } else if (type == 17) {
      this.router.navigateByUrl('/user-profile/Wishlist');
      window.scroll({ top: 0, behavior: 'smooth' });
      this.LoginVisible = false;
    }
  }
  onSelect() {
    this.isLoactionVisible = false;
    this.router.navigateByUrl('/user-profile/add-address');
    window.scroll({ top: 0, behavior: 'smooth' });
  }
  Locationclose() {
    this.isLoactionVisible = false;
    this.pinCode.reset();
  }
  onClickLoaction() {
    this.isLoactionVisible = true;
    this.pinCode.reset();
  }
  checkPincode(type: number) {
    // if (this.pinCode.value.length > 0 || this.pincode.length>0) {
    let body = {
      PinCode: type == 1 ? this.pinCode.value : this.pincode,
    };
    try {
      this._appService
        .postMethod('Pincode', body)

        .subscribe(
          (resp) => {
            if (resp.success) {
              if (type == 1) {
                this.CookieService.set(
                  'pincode',
                  JSON.stringify(+this.pinCode.value)
                );
                this._appService.PinCodeEventEmitter.emit(+this.pinCode.value);
              } else if (type == 2) {
                this.CookieService.set('pincode', JSON.stringify(this.pincode));
                this._appService.PinCodeEventEmitter.emit(this.pincode);
              }
              this.CookieService.set(
                'cityData',
                JSON.stringify(resp.extras.Status)
              );
              this.cityName = resp.extras.Status.Division;

              this.isLoactionVisible = false;
            } else {
            }
          },
          (resp) => {
            // this.errorTip = resp.error.extras.msg
          }
        );
    } catch (e) {}
    // } else {
    //   // this.ValidatingStatus = 'null'
    // }
  }
  // Loguot() {
  // }
  Loguot() {
    let userData = JSON.parse(this.CookieService.get('userData'));
    userData.Name = '';
    userData.USERID = '';
    // JSON.parse(this.CookieService.get('userData')).Name = ""
    // JSON.parse(this.CookieService.get('userData')).USERID = ""

    this.CookieService.set('userData', JSON.stringify(userData));
    let data = {
      userData: userData,
      emittingType: 2,
    };
    this._appService.logOutEventEmitter.emit(data);
    this.nzMessageService.success('Logged Out Successfully');
    this.cartItemsCount = 0;
    this.LoginVisible = false;
    this.router.navigateByUrl('/');
    this.CookieService.delete('userData');
  }

  getProfileInfo() {
    const body = {};

    try {
      this._appService.postMethod('Fetch_User_Profile', body).subscribe(
        (resp) => {
          if (resp.success) {
            this.userName = resp.extras.Data.Name;
            this.userNumber = resp.extras.Data.PhoneNumber;
            this.image = resp.extras.Data.Image_Information.ImageOriginal;
          } else {
          }
        },
        (error) => {}
      );
    } catch (e) {}
  }
  onInput(event: Event, type: any): void {
    const value = (event.target as HTMLInputElement).value;
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      if (value.length > 0) {
        this.skip = 0;
        if (type == 'mobile') {
          this.getAllProductsList(value);
          return;
        }
        if (this.searchMode == '1') {
          this.getAllProductsList(value);
        } else {
          this.getAllCompositionsList(value);
        }
      } else {
        this.ProductListData = [];
      }
    }, 400);
  }
  getAllProductsList(value: any) {
    let pinCode: any = JSON.parse(this.CookieService.get('pincode'));
    this.isProductLoading = true;
    this.isLoading = true;
    this.ProductListData = [];
    let body = {
      skip: 0,
      limit: 20,
      Whether_Catagory_Filter: false,
      categoryId: '',
      warehouseId: localStorage.getItem('warehouseId'),
      Whether_Search_Filter: value.length > 0 ? true : false,
      Search_Input: value,
      PinCode: pinCode,
      DeviceType: 2,
    };
    try {
      this._appService
        .postMethod('List_All_Products', body)
        .pipe(debounceTime(2000), distinctUntilChanged())
        .subscribe(
          (resp) => {
            if (resp.success) {
              this.ProductListData = resp.extras.Data;
              this.isProductLoading = false;
              this.isLoading = false;
            } else {
              // this.nzMessageService.create('error', this._appService.apiMessages[resp.extras.msg]);
              this.isProductLoading = false;
              this.isLoading = false;
            }
          },
          (resp) => {
            this.isProductLoading = false;
            this.isLoading = false;
            this.nzMessageService.create('error', resp.error.extras.msg);
          }
        );
    } catch (e) {}
  }

  getAllCompositionsList(value: any) {
    if (value.length <= 2) {
      this.compositionListData = [];
      return;
    }
    this.isMoleculeLoading = true;
    this.compositionListData = [];
    this.isLoading = true;
    this.brandProducts = false;
    let body = {
      searchString: value,
      DeviceType: 2,
      warehouseId: localStorage.getItem('warehouseId'),
    };
    try {
      this._appService
        .postMethod('Search_MgCompositions', body)
        .pipe(debounceTime(2000), distinctUntilChanged())
        .subscribe(
          (resp) => {
            if (resp.success) {
              this.compositionListData = resp.extras.Data;
              //this.isMoleculeLoading = false
              this.isLoading = false;
            } else {
              // this.nzMessageService.create('error', this._appService.apiMessages[resp.extras.msg]);
              //this.isMoleculeLoading = false
              this.isLoading = false;
            }
          },
          (resp) => {
            this.nzMessageService.create('error', resp.error.extras.msg);
            //this.isMoleculeLoading = false
            this.isLoading = false;
          }
        );
    } catch (e) {}
  }

  onBrandSelect(brand: any) {
    this.isMoleculeLoading = false;
    this.brandProducts = true;
    this.brandProductsList = [];
    this.isLoading = true;
    let body = {
      moleculeCompositionId: brand.genifast_MoleculeId,
      mgId: brand.mgId,
      DeviceType: 2,
    };
    try {
      this._appService
        .postMethod('List_All_Products_MoleculeCompositionId', body)
        .subscribe(
          (resp) => {
            if (resp.success) {
              this.brandProductsList = resp.extras.Data;
              this.isLoading = false;
            } else {
              // this.nzMessageService.create('error', this._appService.apiMessages[resp.extras.msg]);
              this.isLoading = false;
            }
          },
          (resp) => {}
        );
    } catch (e) {}
  }

  onSelectedProduct(data: any) {
    this.search_value = '';
    this.ProductListData = [];
    localStorage.setItem('productid', data.productId);
    this.router.navigate([
      '/product-detail',
      String(data.productName)
        .toLowerCase()
        .replace(/ /g, '_')
        .replace(/\//g, '-and-'),
    ]);
  }
  clearCart(warehouseId: any) {
    let body: any = {
      warehouseId: warehouseId,
      CartID: this.CartId,
    };
    console.log(body);
    try {
      this._appService.postMethod('Clear_User_Cart', body).subscribe(
        (resp) => {
          if (resp.success) {
            this.cartItemsCount = 0;
          } else {
            // this.nzMessageService.create('error', this._appService.apiMessages[resp.extras.msg]);
          }
        },
        (resp) => {}
      );
    } catch (e) {}
  }
  getCartItemsList() {
    console.log('getcart');
    let body = { warehouseId: localStorage.getItem('warehouseId') };
    try {
      this._appService.postMethod('List_All_Cart_Items', body).subscribe(
        (resp) => {
          console.log('sdfsdfsdfdsg sd wegwe');
          if (resp.success) {
            if (resp.extras.Data.warehouseId) {
              this.selectedwarehouse.setValue(resp.extras.Data.warehouseId);
              this.previousWarehouseId = resp.extras.Data.warehouseId;
            } else {
              this.selectedwarehouse.setValue(
                this.warehouseList[0].warehouseId
              );

              this.previousWarehouseId = this.warehouseList[0].warehouseId;
            }
            this.CartId = resp.extras.Data.CartID;
            this._appService.cartInfoEventEmitter.emit(
              resp.extras.Data.Products_Data
            );
            if (resp.extras.Data.Products_Data.length > 0) {
              this.cartItemsCount = resp.extras.Data.Products_Data.length;
            } else {
              this.cartItemsCount = 0;
            }
          } else {
            console.log(resp);
            console.log('testing');
            this.selectedwarehouse.setValue(this.warehouseList[0].warehouseId);

            this.previousWarehouseId = this.warehouseList[0].warehouseId;
          }
        },
        (resp) => {}
      );
    } catch (e) {
      console.log('nocart');
      this.selectedwarehouse.setValue(this.warehouseList[0].warehouseId);

      this.previousWarehouseId = this.warehouseList[0].warehouseId;
    }
  }
  onNavigateToCart() {
    if (this.cartItemsCount > 0) {
      this.router.navigate(['/MyCart']);
    }
  }

  getAllAddresses() {
    const body = {
      skip: 0,
      limit: 10,
    };

    try {
      this._appService.postMethod('List_Address', body).subscribe(
        (resp) => {
          if (resp.success) {
            // if (this.skip == 0) {
            //   this.currentPage = 1
            //   this.TotalItems = resp.extras.Count
            // }
            // this.TotalItems = resp.extras.Count
            this.addressList = resp.extras.Data;
          } else {
            this.nzMessageService.error(resp.extras.msg);
          }
        },
        (error) => {}
      );
    } catch (e) {}
  }
  onselectedAddress(item: any) {
    this.pincode = item.PinCode;
    this.checkPincode(2);
  }
  getCurrentlocation() {
    if (navigator) {
      navigator.geolocation.getCurrentPosition((pos) => {
        this.lng = pos.coords.longitude;
        this.lat = pos.coords.latitude;
        // var geocoder = new google.maps.Geocoder();
        // var latlng = new google.maps.LatLng(this.lat, this.lng);
        // geocoder.geocode({ 'latLng': latlng }, function (results:any, status:any) {
        //   if (status == google.maps.GeocoderStatus.OK) {
        //     if (results[0]) {
        //       console.log(results[0])
        //       var add = results[0].address_components
        //       var zipcode = add[add.length - 1].long_name;
        //       console.log(zipcode)

        //     }

        //   }
        // })

        this.reverseGeoCoding(this.lat, this.lng);
      });
    }
  }
  reverseGeoCoding(lat: number, lng: number) {
    var geocoder = new google.maps.Geocoder();
    var latlng = { lat: lat, lng: lng };
    geocoder.geocode({ location: latlng }, (results: any = [], status: any) => {
      if (status === 'OK') {
        if (results[2]) {
          // this.address_googlePlaces =
          this.displayPostcode(results[0].address_components);
        } else {
        }
      } else {
      }
    });
  }
  displayPostcode(address: any = []) {
    this.pincode = address[address.length - 1].long_name;
    this.checkPincode(2);
  }

  onViewCart(ProductData: any = {}) {
    if (!this.CookieService.check('userData')) {
      this.nzMessageService.warning('please Login');
      this._appService.isWebLoginVisible.emit(true);
      return;
    }
    // if (this.CookieService.check('userData')) {
    if (ProductData.isPrescriptionRequired === 1) {
      if (ProductData.is_Prescription_Validated) {
        this.CookieService.set(
          'productId',
          JSON.stringify(ProductData.productId)
        );
        this.onAddToCart(ProductData);
      } else {
        // this.isPrescriptionUpload = true
        // this.productId = ProductData.Product_ID
        this.router.navigateByUrl('/user-prescription');
      }
    } else {
      this.CookieService.set(
        'productId',
        JSON.stringify(ProductData.productId)
      );
      this.onAddToCart(ProductData);
    }
  }

  onAddToCart(ProductData: any) {
    let body = {
      productId: ProductData.productId,
      Quantity: 1,
      Add_Remove: 1,
      warehouseId: localStorage.getItem('warehouseId'),
    };
    try {
      this._appService
        .postMethod('Add_OR_Remove_Product_To_Cart_Modified', body)
        .subscribe(
          (resp) => {
            if (resp.success) {
              this.nzMessageService.success(resp.extras.Status);
              fbq('track', 'AddToCart');
              this.getCartItemsList();
            } else {
              // this.nzMessageService.create('error', this._appService.apiMessages[resp.extras.msg]);
            }
          },
          (resp) => {
            this.nzMessageService.create('error', resp.error.extras.msg);
          }
        );
    } catch (e) {}
  }
  onproductNotify(cart: any) {
    let body = {
      productId: cart.productId,
      Quantity: 1,
      warehouseId: localStorage.getItem('warehouseId'),
    };
    try {
      this._appService.postMethod('Add_Product_Notify', body).subscribe(
        (resp) => {
          if (resp.success) {
            this.nzMessageService.success('Product Notify Successfully');
            this.getCartItemsList();
          } else {
            // this.nzMessageService.create('error', this._appService.apiMessages[resp.extras.msg]);
          }
        },
        (resp) => {
          this.nzMessageService.create('error', resp.error.extras.msg);
        }
      );
    } catch (e) {}
  }

  listProducts() {
    this.searchMode = '1';
    if (this.search_value) {
      this.getAllProductsList(this.search_value);
    }
  }

  listBrands() {
    this.searchMode = '2';
    if (this.search_value) {
      this.getAllCompositionsList(this.search_value);
    }
  }
}
